import { Result } from '@vaaas/fpts/result';
import { MimeType } from './mime-types';

export function isWebGLPossible(): boolean {
    try {
        return Boolean(
            window.WebGLRenderingContext
            || experimental_webgl()
        );
    } catch(e) {
        return false;
    }
}

function experimental_webgl() {
    return document
        .createElement('canvas')
        .getContext('experimental-webgl');
}

export function is_mobile(): boolean {
    return globalThis.navigator !== undefined
        && navigator.maxTouchPoints !== undefined
        && navigator.maxTouchPoints > 1;
}

export function pointer_is_inside_element(elem: HTMLElement, e: PointerEvent) {
    const rect = elem.getBoundingClientRect();
    return e.clientX > rect.left
        && e.clientX < rect.left + rect.width
        && e.clientY > rect.top
        && e.clientY < rect.top + rect.height;
}

export function return_focus_to_scene() {
    document.activeElement instanceof HTMLElement && document.activeElement.blur();
}

export function load_script(src: string): Promise<Result<HTMLScriptElement>> {
    return new Promise((done) => {
        const script: HTMLScriptElement = document.createElement('script');
        script.async = true;
        script.src = src;
        script.onerror = (event) => done(new Error(`Error loading script: ${src}`, { cause: event })) ;
        script.onload = () => done(script);
        document.head.appendChild(script);
    });
}

export function download_as_file(
    file_name: string,
    mime_type: MimeType,
    contents: string | ArrayBuffer,
): Promise<void> {
    return new Promise(next => {
        const blob = new Blob([contents], { type: mime_type });
        const download_anchor = document.createElement('a');
        download_anchor.download = file_name;
        download_anchor.appendChild(new Text('Download File'));
        download_anchor.href = window.URL.createObjectURL(blob);
        download_anchor.style.display = 'none';
        download_anchor.onclick = () => {
            document.body.removeChild(download_anchor);
            next();
        };

        // Firefox requires the link to be added to the DOM before it can be clicked.
        document.body.appendChild(download_anchor);
        download_anchor.click();
    });
}
